/*global document, window*/
"use strict";

(function () {
  var wrapper = document.querySelector("[data-advantages-wrapper]");
  if (!wrapper) return;

  var container = wrapper.querySelector(".s-advantages__slider-container");
  var track = wrapper.querySelector("[data-advantages-track]");
  var slides = wrapper.querySelectorAll("[data-advantages-slide]");
  var dots = wrapper.querySelectorAll("[data-advantages-dot]");
  var prevBtn = wrapper.querySelector("[data-advantages-prev]");
  var nextBtn = wrapper.querySelector("[data-advantages-next]");

  if (!slides.length) return;

  var totalSlides = slides.length;
  var currentSlide = 0;
  var THROTTLE_MS = 650;
  var throttleTimer = null;
  var wheelActive = false;
  var settling = false;
  var wasInView = false;
  var sectionObs = null;
  var mobileObs = null;

  var updateDots = function (idx) {
    dots.forEach(function (d, i) {
      d.classList.toggle("is-active", i === idx);
      d.setAttribute("data-distance", Math.abs(i - idx));
    });

    if (prevBtn) {
      prevBtn.classList.toggle("is-disabled", idx === 0);
    }

    if (nextBtn) {
      nextBtn.classList.toggle("is-disabled", idx === totalSlides - 1);
    }
  };

  var updateActive = function (idx, dir) {
    slides.forEach(function (s, i) {
      if (i === idx) {
        s.classList.toggle("from-above", dir < 0);
        s.classList.add("is-active");
      } else {
        s.classList.remove("is-active", "from-above");
      }
    });
    updateDots(idx);
  };

  var isInView = function () {
    var rect = container.getBoundingClientRect();
    var mid = rect.top + rect.height / 2;
    var center = window.innerHeight * 0.5;
    return Math.abs(mid - center) < window.innerHeight * 0.2;
  };

  var onWheel = function (e) {
    if (!isInView()) {
      wasInView = false;
      return;
    }

    var dir = e.deltaY > 0 ? 1 : -1;

    // At boundary — release page scroll and reset so next entry re-settles
    if (dir > 0 && currentSlide >= totalSlides - 1) {
      wasInView = false;
      return;
    }
    if (dir < 0 && currentSlide <= 0) {
      wasInView = false;
      return;
    }

    e.preventDefault();

    // First wheel event in the center zone — absorb momentum
    if (!wasInView) {
      wasInView = true;
      settling = true;
      setTimeout(function () {
        settling = false;
      }, 400);
    }

    if (settling || throttleTimer) return;

    currentSlide += dir;
    updateActive(currentSlide, dir);
    throttleTimer = setTimeout(function () {
      throttleTimer = null;
    }, THROTTLE_MS);
  };

  var activate = function () {
    if (wheelActive) return;
    teardownMobile();
    wheelActive = true;

    sectionObs = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry.isIntersecting) return;
        var dir = entry.boundingClientRect.top >= 0 ? 1 : -1;
        currentSlide = dir > 0 ? 0 : totalSlides - 1;
        updateActive(currentSlide, dir);
        wasInView = false; // force re-settle on next wheel entry
      },
      { threshold: 0.6 },
    );
    sectionObs.observe(container);

    window.addEventListener("wheel", onWheel, { passive: false });
  };

  var deactivate = function () {
    if (!wheelActive) return;
    wheelActive = false;
    window.removeEventListener("wheel", onWheel, { passive: false });
    if (sectionObs) {
      sectionObs.disconnect();
      sectionObs = null;
    }
    currentSlide = 0;
    wasInView = false;
    updateActive(0, 1);
    initMobile();
  };

  var initMobile = function () {
    if (mobileObs || !track) return;
    mobileObs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = Array.prototype.indexOf.call(slides, entry.target);
          if (idx === -1 || idx === currentSlide) return;
          currentSlide = idx;
          updateDots(idx);
        });
      },
      { root: track, threshold: 0.5 },
    );
    slides.forEach(function (s) {
      mobileObs.observe(s);
    });
  };

  var teardownMobile = function () {
    if (mobileObs) {
      mobileObs.disconnect();
      mobileObs = null;
    }
  };

  var scrollToSlide = function (idx) {
    if (!track) return;
    var slideEl = slides[idx];
    if (!slideEl) return;
    track.scrollTo({
      left: slideEl.offsetLeft - track.offsetLeft,
      behavior: "smooth",
    });
  };

  var mq = window.matchMedia("(min-width: 1280px)");
  if (mq.matches) {
    activate();
  } else {
    updateActive(0, 1);
    initMobile();
  }
  mq.addEventListener("change", function (e) {
    if (e.matches) activate();
    else deactivate();
  });

  if (prevBtn)
    prevBtn.addEventListener("click", function () {
      if (currentSlide > 0) {
        currentSlide--;
        if (mq.matches) updateActive(currentSlide, -1);
        else {
          updateDots(currentSlide);
          scrollToSlide(currentSlide);
        }
      }
    });

  if (nextBtn)
    nextBtn.addEventListener("click", function () {
      if (currentSlide < totalSlides - 1) {
        currentSlide++;
        if (mq.matches) updateActive(currentSlide, 1);
        else {
          updateDots(currentSlide);
          scrollToSlide(currentSlide);
        }
      }
    });

  dots.forEach(function (dot, i) {
    dot.addEventListener("click", function () {
      var dir = i >= currentSlide ? 1 : -1;
      if (mq.matches) {
        currentSlide = i;
        updateActive(i, dir);
      } else {
        currentSlide = i;
        updateDots(i);
        scrollToSlide(i);
      }
    });
  });
})();
